import React from "react";

import { useParams } from "react-router-dom";

import { DataForm } from "pages/dataCollection/_shared/DataForm";
import { createShareNotice } from "shared/api/ShareNoticeApi";

// 등록 폼 초기값(빈 값). 모듈 상수로 둬 DataForm이 1회만 초기화하도록 안정 참조 유지.
const EMPTY_INITIAL = {
  title: "",
  category: null,
  pin: false,
  content: "",
  files: [],
};

function DataRegister() {
  const { category } = useParams();

  return (
    <DataForm
      mode="create"
      groupId={Number(category)}
      initialValues={EMPTY_INITIAL}
      onSubmit={(data) => createShareNotice(data)}
    />
  );
}

export default DataRegister;
